import { render, staticRenderFns } from "./UploadNotifications.vue?vue&type=template&id=73d397cc"
import script from "./UploadNotifications.vue?vue&type=script&lang=js"
export * from "./UploadNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../Development/graduation/graduate-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports